/**
 * Stat Counter — animates numbers from 0 to target on scroll into viewport
 * Uses IntersectionObserver for performance
 */

export function initStatCounter() {
    const counters = document.querySelectorAll('[data-count-to]');
    if (!counters.length) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const el = entry.target;
                if (el.dataset.counted) return; // Only animate once
                el.dataset.counted = 'true';

                const target = parseFloat(el.dataset.countTo);
                const prefix = el.dataset.countPrefix || '';
                const suffix = el.dataset.countSuffix || '';
                const duration = 2000; // ms
                const startTime = performance.now();
                const isDecimal = target % 1 !== 0;

                function update(now) {
                    const elapsed = now - startTime;
                    const progress = Math.min(elapsed / duration, 1);

                    // Ease-out cubic for a nice deceleration
                    const eased = 1 - Math.pow(1 - progress, 3);

                    const current = eased * target;
                    const display = isDecimal
                        ? current.toFixed(1)
                        : Math.round(current).toLocaleString();

                    el.textContent = `${prefix}${display}${suffix}`;

                    if (progress < 1) {
                        requestAnimationFrame(update);
                    }
                }

                requestAnimationFrame(update);
                observer.unobserve(el);
            });
        },
        { threshold: 0.3 }
    );

    counters.forEach((el) => observer.observe(el));
}
